import { Loader2 } from "lucide-react";
import AppShell from "@/components/AppShell";
import PlanSummary from "@/components/billing/PlanSummary";
import AddonsGrid from "@/components/billing/AddonsGrid";
import BillingHistory from "@/components/billing/BillingHistory";
import { useBilling } from "@/hooks/useBilling";

export default function Billing() {
  const {
    sub, config, history, busy, verifying,
    cancel, resume, downgradeFree, buyAddon, openPortal,
  } = useBilling();

  if (verifying) {
    return (
      <AppShell title="Billing">
        <div className="flex flex-col items-center justify-center py-24 gap-3 text-slate-500">
          <Loader2 className="animate-spin" size={28} />
          <p className="text-sm">Confirming your payment…</p>
        </div>
      </AppShell>
    );
  }

  return (
    <AppShell title="Billing & Subscription" subtitle="Manage your plan, payment and add-ons.">
      <PlanSummary
        sub={sub}
        busy={busy}
        onOpenPortal={openPortal}
        onCancel={cancel}
        onResume={resume}
        onDowngradeFree={downgradeFree}
      />
      <AddonsGrid config={config} busy={busy} onBuy={buyAddon} />
      <BillingHistory history={history} />
    </AppShell>
  );
}
